export default class Overlay {
  constructor(el) {
    this.el = el;
    const container = this.el;
    const close = container.querySelectorAll('[data-close]');
    const trigger = document.querySelectorAll('[data-overlay-trigger]');
    const self = this;

    if (trigger) {
      trigger.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          this.showOverlay(
            container,
            event,
            button
          );
        });
      });

      close.forEach((button) => {
        button.addEventListener('click', function(evt){self.closeOverlay(container, evt);});
      });

      document.onkeydown = (evt) => {
        evt = evt || window.event;
        if (evt.keyCode === 27) {
          this.closeOverlay(container, evt);
        }
      };
    }

    if(el.hasAttribute('data-intervention')) {
      const frequency = el.getAttribute('data-frequency');
      const id = el.getAttribute('data-id');

      if (frequency == 'always') {
          this.showOverlay(container, null, null);
      }

      if (frequency == 'once_session') {
        const shown = sessionStorage.getItem(id + 'interventionOverlayShown');
        if (!shown) {
          sessionStorage.setItem(id + 'interventionOverlayShown', 1);
          this.showOverlay(container, null, null);
        }
      }

      if (frequency == 'daily') {
        if (localStorage) {
          let nextPopup = localStorage.getItem(id + 'interventionOverlayShownDaily');

          if (new Date() > nextPopup) {
            let expires = new Date();
            expires = expires.setHours(expires.getHours() + 24);
        
            localStorage.setItem(id + 'interventionOverlayShownDaily', expires);
            this.showOverlay(container, null, null);
          }
        }
      }

      if (frequency == 'weekly') {
        if (localStorage) {
          let nextPopup = localStorage.getItem(id + 'interventionOverlayShownWeekly');
          
          if (new Date() > nextPopup) {
            let expires = new Date();
            expires = expires.setHours(expires.getHours() + 168);
        
            localStorage.setItem(id + 'interventionOverlayShownWeekly', expires);
            this.showOverlay(container, null, null);
          }
        }
      }
      
    }
  }

  showOverlay(container, event, trigger) {
    if(event) {
      event.preventDefault();
    }


    //const container = document.querySelector('[data-overlay]');
   
    if(trigger) {
      const content = trigger.nextElementSibling.innerHTML;
      trigger.classList.add('is-loading');
      const contentContainer = container.querySelector('.g-overlay__content');
      contentContainer.innerHTML = content;
      trigger.classList.remove('is-loading');
    }

    container.classList.add('is-active');
    document.documentElement.classList.toggle('s-overlay-open');
    
    setTimeout(() => {
      container.classList.add('is-fading-in');
    }, 300);
  }

  closeOverlay(container, event) {
    //const container = document.querySelector('[data-overlay]');

    event.preventDefault();
    document.documentElement.classList.toggle('s-overlay-open');
    container.classList.remove('is-fading-in');
    setTimeout(() => {
      container.classList.remove('is-active');
    }, 300);
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/Overlay.js